import { render, staticRenderFns } from "./ItsBaseColdStorage.vue?vue&type=template&id=bc5a1252&scoped=true&"
import script from "./ItsBaseColdStorage.vue?vue&type=script&lang=js&"
export * from "./ItsBaseColdStorage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc5a1252",
  null
  
)

export default component.exports